import { render, staticRenderFns } from "./ConfirmacionArchivadoDialogComponent.vue?vue&type=template&id=67e1ce7d"
import script from "./ConfirmacionArchivadoDialogComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmacionArchivadoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports